// extracted by mini-css-extract-plugin
export default {"modalOverlay":"VC-z","modalContent":"WC-z","header":"XC-z","close":"YC-z"};